import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';

/**
 * Functional CanDeactivate guard that warns before leaving a page with unsaved work.
 * Usage in routes: canDeactivate: [unsavedChangesGuard]
 * The component must implement HasUnsavedChanges.
 */
export interface HasUnsavedChanges {
  hasUnsavedChanges(): boolean;
}

export const unsavedChangesGuard: CanDeactivateFn<HasUnsavedChanges> = (component) => {
  const translate = inject(TranslateService);

  if (!component.hasUnsavedChanges()) {
    return true;
  }

  return Swal.fire({
    title: translate.instant('COMMON.UNSAVED_CHANGES_TITLE'),
    text: translate.instant('COMMON.UNSAVED_CHANGES_MESSAGE'),
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: translate.instant('COMMON.LEAVE_PAGE'),
    cancelButtonText: translate.instant('COMMON.STAY_PAGE')
  }).then(result => result.isConfirmed);
};
